<mat-form-field>
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    class="country-select-input"
    readonly
    [formControl]="countries"
    [placeholder]="placeholder"
  />
  <span
    (click)="_openCountrySelectDialog($event)"
    (keydown.enter)="_openCountrySelectDialog($event)"
    class="display-input"
    tabindex="0"
    [class.placeholder]="!getDisplayValue()"
    >{{ getDisplayValue() || placeholder }}</span
  >
  <div class="icons">
    <button
      [disabled]="disabled"
      matSuffix
      mat-icon-button
      (click)="_openCountrySelectDialog($event)"
    >
      <mat-icon class="select-icon">travel_explore</mat-icon>
    </button>
  </div>
  @if (countries.hasError("required")) {
    <mat-error>{{ requiredErrorMessage() }}</mat-error>
  }
</mat-form-field>
